import { isPresent } from "neetocist";
import useBreakpoints from "neetocommons/react-utils/useBreakpoints";
import PropTypes from "prop-types";
import { filter, length } from "ramda";

import LeftBlock from "./LeftBlock";
import NavigationLinks from "./Navigation";
import RightBlock from "./RightBlock";

const NavigationHeader = ({
  leftActionBlock,
  navigationLinks,
  rightActionBlock,
}) => {
  const { isSize } = useBreakpoints();
  const isMobile = isSize("mobile");

  const numberOfChildren = length(
    filter(isPresent, [leftActionBlock, navigationLinks, rightActionBlock])
  );

  const gridStyle = {
    gridTemplateColumns: isMobile
      ? `repeat(${
          navigationLinks ? numberOfChildren - 1 : numberOfChildren
        }, auto)`
      : `repeat(${numberOfChildren}, 1fr)`,
  };

  return (
    <div className="w-full">
      <div
        className="neeto-molecules-navigation-header neeto-ui-border-gray-200 neeto-ui-bg-white flex h-16 w-full flex-shrink-0 items-center overflow-x-auto border-b px-2 py-2 md:px-4 lg:px-6"
        data-testid="navigation-header"
      >
        <div className="grid w-full gap-4" style={gridStyle}>
          {leftActionBlock}
          {!isMobile && navigationLinks}
          {rightActionBlock}
        </div>
      </div>
      {isMobile && (
        <div className="neeto-molecules-navigation-header neeto-ui-border-gray-200 neeto-ui-bg-white flex flex-shrink-0 items-center overflow-x-auto border-b px-4 py-2 lg:px-6">
          {navigationLinks}
        </div>
      )}
    </div>
  );
};

NavigationHeader.LeftActionBlock = LeftBlock;
NavigationHeader.NavigationLinks = NavigationLinks;
NavigationHeader.RightActionBlock = RightBlock;

NavigationHeader.propTypes = {
  /**
   * To specify the content to be rendered in the left side of the `NavigationHeader`.
   */
  leftActionBlock: PropTypes.node,
  /**
   * To specify the content to be rendered at the center of the `NavigationHeader`.
   */
  navigationLinks: PropTypes.node,
  /**
   * To specify the content to be rendered in the right side of the `NavigationHeader`.
   */
  rightActionBlock: PropTypes.node,
};

export default NavigationHeader;
